// extracted by mini-css-extract-plugin
export default {"checkboxes":"multipleChoice_checkboxes__f314X","selectAll":"multipleChoice_selectAll__XN5i0","options":"multipleChoice_options__8IQg6"};